/// <reference path="../../_references.ts" />
module onvio.setup.list {
    'use strict';

    class LateFeeTemplateServiceProxy {

        static $inject = [
            '$injector',
            '$q',
            'fef.PromiseUtils',
            'fef.Utils',
            'csLateFeeTemplateV1'
        ];

        constructor(
            private $injector: ng.auto.IInjectorService,
            private $q: ng.IQService,
            private promiseUtils: fef.IPromiseUtilsService,
            private utils: fef.IUtilsService,
            private lateFeeTemplateV1: cs.ILateFeeTemplateV1Service) {
        }

        getList(params:cs.IQueryFilter): ng.IPromise<cs.IPagedItemsDto<cs.ILateFeeTemplateV1Dto>> {
            return this.lateFeeTemplateV1.postSearch(bmp.PostSearchUtils.convertGetListParamsToSearchParams(params));
        }

        get(params: any): ng.IPromise<cs.ILateFeeTemplateV1Dto> {
            return this.lateFeeTemplateV1.get(params);
        }

        getDefault(params: any): ng.IPromise<cs.ILateFeeTemplateV1Dto> {
            return this.lateFeeTemplateV1.getDefault(params);
        }

        post(params: {
            data: cs.ILateFeeTemplateV1Dto;
        }): ng.IPromise<cs.ILateFeeTemplateV1Dto> {
            return this.lateFeeTemplateV1.post(params);
        }

        put(params: {
            lateFeeTemplateId: string;
            data: any;
        }): ng.IPromise<cs.IHasCompanyDto> {
            return this.lateFeeTemplateV1.put(params);
        }

        delete(params: {
            lateFeeTemplateId: string;
        }): ng.IPromise<cs.ILateFeeTemplateV1Dto> {
            return this.lateFeeTemplateV1.delete(params, true);
        }

    }

    angular.module('onvio.setup.list.LateFeeTemplateServiceProxy',
        [
            'fef',
            'csLateFeeTemplateV1'
        ])
        .service('onvio.setup.list.LateFeeTemplateServiceProxy', LateFeeTemplateServiceProxy);
}
